import React, { ReactNode } from "react";
import {
  PageSectionProps,
  SectionSlideshow,
  SectionSlideshowStatPropsWithKey,
  Theme,
} from "@literati/public-ui-shared-react";

/** This is the className that will be pre-pended to all of TeacherPartnerSectionReaderStats's inner component classNames */
export const TEACHER_PARTNER_SECTION_READER_STATS_CLASS_BASE =
  "teacher-partner-section-reader-stats";

/** These are all of the internal classNames that are used within the TeacherPartnerSectionReaderStats component */
export const TeacherPartnerSectionReaderStatsClassName = {
  BASE: TEACHER_PARTNER_SECTION_READER_STATS_CLASS_BASE,
} as const;

export interface TeacherPartnerSectionReaderStatsProps
  extends Omit<PageSectionProps, "children"> {
  className?: string;
  eyebrow: ReactNode;
  statsItems?: SectionSlideshowStatPropsWithKey[];
}

export const statsItemsDefaults = [
  {
    value: "39 mins",
    description:
      "average increase in daily reading time reported by Literati parents",
    key: "stats-item-0",
  },
  {
    value: "75%",
    description:
      "of members say Literati has increased their kid’s interest in reading",
    key: "stats-item-1",
  },
  {
    value: "81%",
    description:
      "of parents say their child found a favorite book with Literati",
    key: "stats-item-2",
  },
];

export const TeacherPartnerSectionReaderStats = ({
  className = "",
  eyebrow,
  statsItems = statsItemsDefaults,
  ...pageSectionProps
}: TeacherPartnerSectionReaderStatsProps) => {
  return (
    <Theme>
      <SectionSlideshow
        className={`${TeacherPartnerSectionReaderStatsClassName.BASE} ${className}`}
        pageSectionProps={{
          bgColor: "periwinkleTint5",
          eyebrow,
          ...pageSectionProps,
        }}
        statItems={statsItems}
        variant="stats"
      />
    </Theme>
  );
};

export default TeacherPartnerSectionReaderStats;
